import SelectAddress from './SelectAddress'

export default SelectAddress
